import { render } from "./Pagination.vue?vue&type=template&id=1d089ecc"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=1d089ecc&lang=scss"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__